import { render } from "./Elements.vue?vue&type=template&id=b41f3308&scoped=true"
import script from "./Elements.vue?vue&type=script&lang=js"
export * from "./Elements.vue?vue&type=script&lang=js"

import "./Elements.vue?vue&type=style&index=0&id=b41f3308&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b41f3308"]])

export default __exports__